// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._11c8lodh{font:var(--ds-font-heading-medium,normal 500 20px/24px ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}\n._zulppxbi{gap:var(--ds-space-200,1pc)}\n._19pkmgjw{margin-top:var(--ds-space-negative-200,-1pc)}\n._1e0c1txw{display:flex}\n._2lx21bp4{flex-direction:column}\n._otyrpxbi{margin-bottom:var(--ds-space-200,1pc)}\n._syaz1fxt{color:var(--ds-text,#172b4d)}", ""]);
// Exports
module.exports = exports;
